module.exports = __webpack_public_path__ + "img/shopping.644b5b44.svg";